import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    title1: {
        id: "intro.embed.1.title",
    },
    title2: {
        id: "intro.solfaname.3.title",
    },
    title3: {
        id: "intro.embed.2.title",
    },
    description1: {
        id: "intro.subscore.1.description",
    },
    description2: {
        id: "intro.subscore.2.description",
    },
    description3: {
        id: "intro.subscore.3.description",
    },
});

export default messages;
